import React from 'react';
import {DatePicker} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/ja_JP';

const TrackedAtFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <>
      <DatePicker
        placeholder="開始日"
        value={query.trackedAtFrom && moment(query.trackedAtFrom)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, trackedAtFrom: value?.format()});
        }}
        className="w-36"
      />
      <span className="mx-1 mt-2">~</span>
      <DatePicker
        placeholder="終了日"
        value={query.trackedAtTo && moment(query.trackedAtTo)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, trackedAtTo: value?.format()});
        }}
        className="w-36"
      />
    </>
  );
};

export default TrackedAtFilter;
